import { useState } from "react";

import { Button, PickupScheduleSummaryWrapper, Separator, TextDisplay } from "src/styled";
import { translate } from "src/services";
import { WizardSteps } from "../../SchedulerWizardPage";
import AddressSummaryCard from "./AddressSummaryCard";
import ContactSummarySection from "./ContactSummarySection";
import ContactUsModal from "../../modals/ContactUsModal";
import ItemsSummarySection from "./ItemsSummarySection";

interface Props {
  isSummary: boolean;
  setStep: (step: WizardSteps) => void;
  step: WizardSteps;
}

const SummarySection = ({ isSummary, setStep, step }: Props) => {
  const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);

  const displayEditContactButton = step !== WizardSteps.contactInfo;

  const displayItemsEditButton =
    step !== WizardSteps.itemsSelection && step !== WizardSteps.confirmation && !isSummary;

  const displayEditAddressButton =
    step !== WizardSteps.address && step !== WizardSteps.confirmation && !isSummary;

  return (
    <>
      <PickupScheduleSummaryWrapper>
        <TextDisplay size="xLarge" block weight="medium">
          {translate("wizardPage.summary")}
        </TextDisplay>
        <Separator height={30} />

        <AddressSummaryCard
          displayEditButton={displayEditAddressButton}
          onEditClick={() => setStep(WizardSteps.address)}
        />

        <ItemsSummarySection
          isSummary={isSummary}
          displayEditButton={displayItemsEditButton}
          onEditClick={() => setStep(WizardSteps.itemsSelection)}
        />

        <ContactSummarySection
          displayEditButton={displayEditContactButton}
          onEditClick={() => setStep(WizardSteps.contactInfo)}
        />

        {isSummary && (
          <TextDisplay
            size="small"
            color="grayDarker"
            margin="xSmall no no"
            desktopMargin="medium no no"
            lineHeight="120%"
            block
          >
            {translate("wizardPage.contactPrompt")}&nbsp;
            <Button color="primary" text padding="no" onClick={() => setIsContactUsModalOpen(true)}>
              {translate("wizardPage.contactUs")}.
            </Button>
          </TextDisplay>
        )}
      </PickupScheduleSummaryWrapper>

      {isContactUsModalOpen && <ContactUsModal closeModal={() => setIsContactUsModalOpen(false)} />}
    </>
  );
};

export default SummarySection;
